import { Component, HostBinding } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { CoreService } from '../core.service'
import { MoneyPipe, tzDatePipe } from '../app.pipes';
import { ScheduleService } from '../schedule/schedule.service'
import { ProfileService } from '../profile/profile.service';

@Component({
	selector: 'app-simulator',
	imports: [ CommonModule, MoneyPipe, tzDatePipe, FormsModule ],
	templateUrl: './simulator.component.html',
	styleUrl: './simulator.component.scss'
})
export class SimulatorComponent {

	constructor( public core: CoreService, public schedule: ScheduleService, public profile: ProfileService ){}

	subscriptions = [];
	ngOnDestroy() {
		for( let sub of this.subscriptions ) sub.unsubscribe();
	}
	ngOnInit() {

		this.subscriptions.push(
			this.schedule.on_clock_tick.subscribe( () => this.valid_games_mark() )
		);
		this.valid_games_mark();

		this.subscriptions.push(
			this.core.events.subscribe( (e) => {
				if( e != 'profile.auth-changed' ) return;
				this.user = this.profile.user;
			})
		);

		this.subscriptions.push(
			this.core.stateshot_synced.subscribe( () => this.stateshot_parse() )
		);
		this.stateshot_parse();

		this.user = this.profile.user;
	}
	stateshot_parse(){
		this.rules = this.core.stateshot['comp_betting'] && this.core.stateshot['comp_betting']['rules'];
	}

	rules = null;
	user = null;


	valid_game_ids: Set<number> = new Set(); //game_id of no longer betable games...
	valid_games_mark(){
		this.valid_game_ids.clear();
		if( !this.rules ) return;
		if( !this.core.games ) return;

		let cutoff_timestamp = this.schedule.clock_timestamp + 300000; //in 5 Minutes

		for( let g of this.core.games ){

			//And old style odds
			if( !g.away_odd || !g.home_odd ) continue

			//skip if not Warm up or scheduled
			if( !'SW'.includes( g.status ) ) continue

			//skip if cutoff has reached
			if( g.datetime && g.datetime.getTime() < cutoff_timestamp ) continue;

			this.valid_game_ids.add( g.id );
		}
	}


	//Betsim
	amounts: any = {}; //game_id -> number (-100 -> 100)
	checked: any = {}; //game_id -> 'A' or 'H'
	errors:  any = {}; //game_id -> msg


	confirming: Set<number> = new Set(); //game_ids of games being OKed.
	bettings:   Set<number> = new Set(); //game_ids of bets being sent to the server
	beating: Set<number> = new Set(); //game_id

	get maxAmount(): number {
		let balance = this.profile.user.balance;
		return +Math.max(+balance*0.03, Math.min(2,+balance)).toFixed(2)
	}


	gameToggleSide( game, side ) {
		if( this.checked[game.id] == side )
			this.checked[game.id] = null;
		else
			this.checked[game.id] = side;
	}
	gameOddFormat( game, side ){
		if( side == "A" )
			return game.away_odd

		if( side == "H" )
			return game.home_odd
	}
	gameMinAmount( game ): number {
		let ratio = ( this.checked[game.id] == 'A' ? game.away_odd : game.home_odd );
		if( ratio > 2 ) return 1;
		return 1 / ( ratio - 1 )
	}
	gamePayout( game ): number {
		if( !this.amounts[game.id] )
			return 0

		return this.amounts[game.id] * ((this.checked[game.id] == 'A' ) ? game.away_odd : game.home_odd)
	}
	gameConfirmBet( game, node ): void {
		if( !node.checkValidity() || !this.amounts[game.id] )
			return

		this.confirming.add(game.id)
	}
	async gamePlaceBet( game, node ) {

		if( this.bettings.has(game.id) ) return;

		if( !this.profile.is_authenticated ){
			this.core.events.emit("profile.auth-required");
			return;
		}

		this.bettings.add(game.id)

		let response = await this.core.json_request("POST", "/api/v1/prediction/place_bet",
			{
				'game_id': game.id, 'on' : this.checked[game.id], 'home_odd' : game.home_odd, 'away_odd' : game.away_odd,
				'amount' : this.amounts[game.id],
				'token': this.profile.user.token
			},
		)

		if( response.status_code != 201 ){
			this.bettings.delete(game.id)
			this.errors[game.id] = response.error_type;
			return;
		}

		delete this.amounts[game.id];
		delete this.checked[game.id];
		this.bettings.delete(game.id)
		this.profile.authenticate();

	}

	//Simple Template Logic:
	betsimGuideShown: boolean = false;
	close_guide_panel(event, node): void {
		if( event.target == node ) this.betsimGuideShown = false;
	}




}
